import React from "react";
import "./advanced-loader.scss";

export const AdvancedLoader: React.FunctionComponent = () => {
	return (
		<div className="advanced_loader_container">
			<div className="advanced_loader_thumb">
				<div className="inner_thumb"></div>
			</div>
		</div>
	);
};
